import React, { useState } from 'react';
import { AppContainer, Header, Logo, SendButton } from './styles/styled';
import Chat from './components/Chat';
import LandingPage from './components/LandingPage';
import { useAuth } from './contexts/AuthContext';
import AuthModal from './components/AuthModal';
import * as api from './services/api';

const App: React.FC = () => {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState<boolean>(() => {
    return localStorage.getItem('terms_accepted') === 'true';
  });

  const { user, logout } = useAuth();
  const [isAuthModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<'signin' | 'signup'>('signin');
  const [guestResetKey, setGuestResetKey] = useState(0);

  const handleAcceptTerms = () => {
    localStorage.setItem('terms_accepted', 'true');
    setHasAcceptedTerms(true);
  };

  const handleSignIn = () => {
    setAuthMode('signin');
    setAuthModalOpen(true);
  };

  const onSignupSuccess = () => {
    setAuthModalOpen(false);
  };

  const handleClearLocal = async () => {
    if (!window.confirm('Clear your local chat history? This cannot be undone.')) return;
    const sessionId = localStorage.getItem('chat_session_id');
    if (sessionId) {
      // Best-effort backend cleanup; the real "local" reset is the localStorage
      // wipe + Chat re-mount below, so we don't block on this.
      api.clearChatHistory(sessionId).catch(err => console.warn('Backend clear failed:', err));
    }
    localStorage.removeItem('chat_session_id');
    setGuestResetKey(k => k + 1);
  };

  if (!hasAcceptedTerms) {
    return <LandingPage onAcceptTerms={handleAcceptTerms} />;
  }

  return (
    <AppContainer>
      <Header>
        <Logo>DM Slide 💋😈</Logo>
        <div style={{ display: 'flex', gap: '10px' }}>
          {!user ? (
            <>
              <SendButton
                onClick={handleClearLocal}
                style={{ padding: '8px 16px', fontSize: '0.9rem', background: '#444' }}
                title="Wipe the chat on this device. Sign in to save chats permanently across devices."
              >
                Clear History
              </SendButton>
              <SendButton
                onClick={handleSignIn}
                style={{ padding: '8px 16px', fontSize: '0.9rem', background: '#444' }}
              >
                Sign In
              </SendButton>
            </>
          ) : (
            <SendButton
              onClick={() => logout()}
              style={{ padding: '8px 16px', fontSize: '0.9rem', background: '#444' }}
            >
              Logout
            </SendButton>
          )}
        </div>
      </Header>
      <Chat key={guestResetKey} />
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setAuthModalOpen(false)}
        initialMode={authMode}
        onSignupSuccess={onSignupSuccess}
      />
    </AppContainer>
  );
};

export default App;
